import MultiJackpotView from './multi_jackpot_view';

export default MultiJackpotView;
